import React, { useState, useContext } from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { StudentDetailsContext } from "../store/student-details";
import { Modal,Snackbar } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SearchIcon from '@mui/icons-material/Search';
import PublishIcon from '@mui/icons-material/Publish';
import CloseIcon from '@mui/icons-material/Close'; 
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import GroupsIcon from '@mui/icons-material/Groups';
const ExamsScreen = () => {
  const StudentContext = useContext(StudentDetailsContext);
  const [admissionId, setAdmissionId] = useState(0);
  const [showModal, handleModal] = useState(false);
  const [studentMarks,setStudentMarks] = useState({
    Telugu:'',Hindi:'',English:'',Maths:'',Physics:'',Biology:'',Social:''
  });
  
  function uploadMarks(e) {
    e.preventDefault();
    let examName = "Formative Assessment - 1";  
    let studentName = StudentContext && StudentContext.personalDetails.Name;
    let className = StudentContext && StudentContext.personalDetails.className;
    StudentContext.uploadExamMarksByAdmissionNumber(admissionId,examName,className,studentName,studentMarks);
  }
  function viewMoreHandler() {
    // StudentContext.created = false; 
    StudentContext.updateCreatedState();
    handleModal(!showModal);
  }
  function searchStudent(e){
    e.preventDefault();
    StudentContext.getStudentDetailsByAdmission(admissionId);
    
  }
  function onChangeFun(e){
    setAdmissionId(e.target.value);
    // StudentContext.getStudentDetailsByAdmission(admissionId);
   
  }
  return (
    <div className="dashboardMainDiv">
      <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer ">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent ">
        <div className="container dashboardContentContainer">
            <div className="row">
                <div className="col-lg-4">
                <div className='card'>
                    <div className="card-body">
                        <p>Exam Name : First Unit Test</p>
                        <p>Class Name : 10th class</p>
                        <button className="btn btn-sm btn-primary px-5"
                        onClick={viewMoreHandler}>Upload Marks</button>
                    </div>
                </div>
                </div>

                <div className="col-lg-4">
                <div className='card'>
                    <div className="card-body">
                        <p>Exam Name : First Unit Test</p>
                        <p>Class Name : 10th class</p>
                        <Link to="/viewMarks">
                        <button className="btn btn-sm btn-warning px-5">View Uploaded Marks</button>
                        </Link>
                    </div>
                </div>
                </div>

            </div>
            {
                <Modal open={showModal}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 mt-5">
                            
                                <div className="card">
                                <p className="text text-center text-success mt-3  py-1 col-lg-8 ml-5">FIRST UNIT TEST EXAM MARKS</p>
                                <div style={{position:"absolute",top:0,right:'10px'}}>
                                    <button className="btn btn-sm btn-secondary mt-3"
                                    onClick={viewMoreHandler}>close <CloseIcon style={{fontSize:"14px"}}/> </button>
                                </div>
                                    <div className="col-lg-10 mt-5 px-5">
                                    {StudentContext && StudentContext.created ? <>
                                      <Snackbar
                                      open={StudentContext.created}
                                      autoHideDuration={3000}
                                      onClose={viewMoreHandler}
                                      message="Marks Uploaded Successfully"/>
                                    </> : <></>}
                                    <form className="form" >
                                        <div className="input-group form-group">
                                            <input type="text" placeholder="Enter student admission id" className="form-control"
                                                onChange = { (e)=> {onChangeFun(e)}}
                                            />
                                            <button className="btn btn-sm btn-success"
                                            onClick={(e)=>{searchStudent(e)}}>Search&nbsp;<SearchIcon fontSize="25"/> </button>
                                        </div>

                                        <div className="form-group">
                                            <input type="text" placeholder={(StudentContext && StudentContext.personalDetails.Name)  ? "":"Student Name"} className="form-control"
                                                value = {StudentContext && StudentContext.personalDetails.Name? StudentContext.personalDetails.Name:''}
                                                disabled    
                                            />
                                        </div>
                                        <div className="form-group d-flex flex-row justify-content-between">
                                           <div className="d-flex flex-column ">
                                            <label className="mt-1">Telugu</label>
                                            <label className="mt-3">Hindi</label>
                                            <label className="mt-3">English</label>
                                            <label className="mt-3">Maths</label>
                                            <label className="mt-3">Physics</label>
                                            <label className="mt-3">Biology</label>
                                            <label className="mt-3">Social</label>
                                           </div>
                                           <div className="d-flex flex-column col-lg-8">
                                           <input name="Telugu" placeholder="Enter student telugu marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="Hindi" placeholder="Enter student hindi marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="English" placeholder="Enter student English marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="Maths" placeholder="Enter student Math marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="Physics" placeholder="Enter student Physics marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="Biology" placeholder="Enter student Biology marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                            <input name="Social" placeholder="Enter student Social marks" className="mt-2 form-control "
                                                onChange = { (e)=> {setStudentMarks((currMarks)=>({...currMarks,[e.target.name]:e.target.value}));}}
                                            />
                                           </div>
                                        </div>
                                        
                                        <div className="form-group d-flex flex-row justify-content-end align-items-center mt-5">
                                            {/* <input type="text" placeholder="Enter student admission id" className="form-control"/> */}
                                            <button className="col-lg-3 py-2 btn btn-sm btn-info"
                                           onClick={(e)=>{uploadMarks(e)}}
                                            >Upload Marks &nbsp; <PublishIcon style={{fontSize:'20px'}}/></button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </div>
      </div>
    </div>
  );
};

export default ExamsScreen;
